import { RoutesMounter } from '../../types';
import SubcontractorsIndex from './pages/SubcontractorsIndex';

export const mountSubcontractorsRoutes: RoutesMounter = ({ path }) => [
  {
    path,
    children: [{ index: true, element: <SubcontractorsIndex /> }],
  },
];
